
import Vue from "vue";
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import DashboardPlugin from "./material-dashboard";
// Plugins
import Chartist from "chartist";

// router setup
import router from "./routes/index";
import VueSplit from 'vue-split-panel';
import store from "./store/index";
import Vuetify from 'vuetify'

// 工具类
import dic from '@/util/dic'
import VueSweetalert2 from 'vue-sweetalert2'

import request from './util/request';
import Msg from './util/notification';

import App from "./App.vue";

//driver.js多处使用
import Driver from 'driver.js';
import 'driver.js/dist/driver.min.css';

import VueTour from 'vue-tour';
import 'vue-tour/dist/vue-tour.css';

import "./assets/fonts/iconfont";
import "./assets/fonts/iconfont.css";

// import VueAwesomeSwiper from 'vue-awesome-swiper'
// import 'swiper/dist/css/swiper.css'
// import "swiper/swiper.min.css"
// 全局挂载
// Vue.use(VueAwesomeSwiper)

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
// 全局挂载
Vue.use(VueAwesomeSwiper)
Vue.prototype.driver = new Driver({
  doneBtnText: '完成',
  closeBtnText: '关闭',
  stageBackground: '#fff',
  nextBtnText: '下一步',
  prevBtnText: '上一步',
})

// 全局工具类
Vue.prototype.$dic = dic
Vue.prototype.$http = request;
Vue.prototype.$Msg = Msg;


import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
Vue.config.devtools = true;

// plugin setup
Vue.use(DashboardPlugin);
Vue.use(VueSweetalert2);
Vue.use(Vuetify)
Vue.use(VueSplit);
Vue.use(VueTour);

Vue.prototype.$EventBus = new Vue();
//解决控制台警告
// import 'default-passive-events'
// global library setup
Vue.prototype.$Chartist = Chartist;
Vue.prototype.$click = click;
import { SlideYDownTransition } from 'vue2-transitions'
Vue.component('SlideYDownTransition', SlideYDownTransition)
Vue.component('MdSelect', Vue.options.components.MdSelect.extend({
	methods: {
			isInvalidValue: function isInvalidValue () {
					return this.$el.validity ? this.$el.validity.badInput : this.$el.querySelector('input').validity.badInput
			}
	}
}))

Vue.directive('hasPermi', (el, binding, vnode) => {
	const { value } = binding
	const all_permission = "*:*:*";
	const permissions = store.getters && store.getters.permissions
	
	if (value && value instanceof Array && value.length > 0) {
		const permissionFlag = value
		const hasPermissions = permissions.some(permission => {
		return all_permission === permission || permissionFlag.includes(permission)
		})

		if (!hasPermissions) {
			let index = setTimeout(() => {
				el && el.remove()
				el.parentNode && el.parentNode.removeChild(el);
				clearTimeout(index);
			}, 1)
		}
	} else {
		throw new Error(`请设置操作权限标签值`)
	}
})

import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')

Vue.use(VideoPlayer)


// import SocketIO from 'socket.io-client';
// import vueSocketio from 'vue-socket.io';
// Vue.use(new vueSocketio({
//   debug: true,
//   connection: SocketIO('http://localhost:4001'),
// }))

/* eslint-disable no-new */
let app = new Vue({
  el: "#app",
  render: (h) => h(App),
  store,
  router,
  vuetify: new Vuetify(),
});

function click (dom) {          
	if (document.all) {
		dom.click();          
	} else {              
		var evt = document.createEvent("MouseEvents");              
		evt.initEvent("click", true, true);              
		dom.dispatchEvent(evt);          
	}
}
export default  app